import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router";
import { Button, Field, Input, MessageBar, MessageBarBody, Text } from "@fluentui/react-components";
import { AuthCard } from "../components/AuthCard.tsx";
import { api } from "../lib/api.ts";
import { useAuth } from "../lib/auth.tsx";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post("/api/auth/forgot-password", { email });
    setSent(true);
  };
  return (
    <AuthCard title="Reset your password" subtitle="We'll send a link if that email has an account.">
      {sent ? (
        <Text>If that address is registered you'll get a reset link shortly. It's valid for one hour.</Text>
      ) : (
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Field label="Email" required>
            <Input type="email" autoComplete="email" value={email} onChange={(_, d) => setEmail(d.value)} />
          </Field>
          <Button appearance="primary" type="submit">Send reset link</Button>
          <Link to="/login">Back to sign in</Link>
        </form>
      )}
    </AuthCard>
  );
}

export function ResetPasswordPage() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post("/api/auth/reset-password", { token, password });
      await refresh();
      nav("/", { replace: true });
    } catch (ex) {
      setErr((ex as Error).message);
    }
  };
  return (
    <AuthCard title="Choose a new password">
      <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {err && (
          <MessageBar intent="error">
            <MessageBarBody>{err}</MessageBarBody>
          </MessageBar>
        )}
        <Field label="New password" required hint="At least 10 characters">
          <Input type="password" autoComplete="new-password" value={password} onChange={(_, d) => setPassword(d.value)} />
        </Field>
        <Button appearance="primary" type="submit" disabled={password.length < 10}>Set password</Button>
      </form>
    </AuthCard>
  );
}
